import { Component, input, signal } from '@angular/core';
import { SidebarItemModel } from '../../models/sidebar-item.model';
import { animate, style, transition, trigger } from '@angular/animations';
import { AuthorizationService } from '../../services/authorization.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent {
  item = input.required<SidebarItemModel>();
  collapsed = input(false);
  nestedMenuOpen = signal(false);
   constructor(private authorizationService: AuthorizationService
    ){
       
    }
  toggleNested(){
    if(!this.item().subItems){
      return ;
    }
    this.nestedMenuOpen.set(!this.nestedMenuOpen());
  }
  public hasPermission(functionName: string): boolean {
    return this.authorizationService.isAuthorizationByPerm(functionName);
  }
}
